import { render, staticRenderFns } from "./MetricHistory.vue?vue&type=template&id=2e0bd7cc&"
import script from "./MetricHistory.vue?vue&type=script&lang=ts&"
export * from "./MetricHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports